import React from 'react';

/**
 * Lucide "x", stroked in currentColor. The repo carries no icon library, so
 * the few Lucide glyphs the designs name live here as inline SVGs (see
 * SendingIcon for the first one).
 */
const CloseIcon: React.FC<{ size?: number; className?: string }> = ({ size = 16, className }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    className={className}
    aria-hidden
    focusable="false"
  >
    <path d="M18 6 6 18" />
    <path d="m6 6 12 12" />
  </svg>
);

export default CloseIcon;
